 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Bank No
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryBankNoFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryBankNoFilterForm"
                            v-model="filtersBankNo.bankNo"
                            :label="filtersBankNoLabel.bankNo"
                            :error-messages="errors.collect('filterBankNo')"
                            data-vv-name="filterBankNo"
                            :data-vv-as="filtersBankNoLabel.bankNo"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearBankNoFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doBankNoFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2" v-if="objData === 'screen_1'">
        <v-data-table
          :headers="bankNoHeaders_1"
          :items="bankNoItems"
          v-bind:options.sync="paginationBankNo"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsBankNo"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.defPayBank }}</td>
              <td>{{ row.item.defPayBankDesc }}</td>
              <td>{{ row.item.fullBankNo }}</td>
              <td>{{ row.item.bankAcctBal }}</td>
              <td>{{ row.item.bankAcctCurrency }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignBank(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr></template
          >
        </v-data-table>
      </v-flex>
      <v-flex xs12 class="mt-2" v-if="objData === 'screen_2'">
        <v-data-table
          :headers="bankNoHeaders_2"
          :items="bankNoItems"
          v-bind:options.sync="paginationBankNo"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsBankNo"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.defPayBank }}</td>
              <td>{{ row.item.defPayBankDesc }}</td>
              <td>{{ row.item.fullBankNo }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignBank(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr></template
          >
        </v-data-table>
      </v-flex>
      <v-flex xs12 class="mt-2" v-if="objData === 'screen_3'">
        <v-data-table
          :headers="bankNoHeaders_3"
          :items="bankNoItems"
          v-bind:options.sync="paginationBankNo"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsBankNo"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.defPayBank }}</td>
              <td>{{ row.item.defPayBankDesc }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignBank(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr></template
          >
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      actionName: '',
      filtersBankNoLabel: {
        bankNo: 'Bank No.'
      },
      filtersBankNo: {
        bankNo: undefined
      },
      bankNoItems: [],
      totalItemsBankNo: 0,
      bankNoHeaders_1: [
        { text: 'Bank No.', align: 'left', value: 'bankNo' },
        { text: 'Bank Account Name', value: 'bankAcctName' },
        { text: 'Full Bank No.', value: 'fullBankNo' },
        { text: 'Balance', value: 'bankAcctBal' },
        { text: 'Currency', value: 'bankAcctCurrency' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      bankNoHeaders_2: [
        { text: 'Bank No.', align: 'left', value: 'bankNo' },
        { text: 'Bank Account Name', value: 'bankAcctName' },
        { text: 'Full Bank No.', value: 'fullBankNo' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      bankNoHeaders_3: [
        { text: 'Bank No.', align: 'left', value: 'bankNo' },
        { text: 'Bank Account Name', value: 'bankAcctName' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationBankNo: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  watch: {
    boolRefresh: function (value) {
      if (value) {
        this.doClearBankNoFilters()
      }
    },
    'paginationBankNo': function (value) {
      this.fetchBankNoData()
    }
  },
  mounted() {
  },
  methods: {
    doFilterOnEnter() {
      this.doBankNoFilters()
      event.preventDefault()
    },
    closeDialog() {
      this.filtersBankNo.bankNo = ''
      this.$emit('close')
    },
    doClearBankNoFilters() {
      this.filtersBankNo.bankNo = ''
      this.fetchBankNoData()
    },
    doBankNoFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryBankNoFilterForm').then((result) => {
        if (result) {
          this.paginationBankNo.page = 1
          this.fetchBankNoData()
        }
      })
    },
    assignBank(data) {
      // Use $emit to call parent Accounts page method assignBank and pass the value
      this.$emit('assign-bank-info', data)
      this.$emit('assign-bank', data.defPayBank)
      this.$emit('close')
    }
  },
  computed: {},
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    },
    objData: {
      type: String,
      default: null
    }
  },
  mixins: [TableConst.default, commonAjaxMixin]
}
</script>
